import {StyleProps, theme as defaultTheme} from '@miro-site/design-tokens'

const InputStyles: Record<string, StyleProps> = {
  container: {
    position: 'relative',
    marginTop: [6, 6, 6, 9],
    ':first-child': {
      marginTop: 0,
    },
  },

  wrapper: {
    position: 'relative',
  },

  field: {
    position: 'relative',
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    border: '1px solid',
    fontFamily: 'Formular',
    fontFeatureSettings: '"zero", "ss02", "ss06", "ss05"',
    fontWeight: 'normal',
    appearance: 'none',
    outline: 'none',
    color: 'primaryIndigo',
    borderRadius: [4, 4, 4, 6],
    transition: 'border @transitionDuration',
    background: 'transparent',
    zIndex: 1,
    height: [48, 48, 48, 72],
    fontSize: [18, 18, 18, 27],
    lineHeight: [24, 24, 24, 36],
    paddingLeft: [40, 40, 40, 60],
    paddingRight: [40, 40, 40, 60],
    paddingBottom: [3, 3, 3, 4.5],
    '::placeholder': {
      color: 'placeholderColor',
    },
    ':focus': {
      ...defaultTheme.focus.outlines.default,
      borderColor: 'primaryBlueHover',
    },
  },

  icon: {
    width: [16, 16, 16, 24],
    height: [16, 16, 16, 24],
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: '50%',
    left: [16, 16, 16, 24],
    transform: 'translateY(-50%)',
    zIndex: 0,
  },

  error: {
    color: 'bold',
    fontSize: [14, 14, 14, 21],
    lineHeight: [20, 20, 20, 30],
    marginTop: 4,
    marginBottom: 12,
  },
}

export default InputStyles
